import {
  Body,
  Button,
  CardAction,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@e2n/ui/v2';
import dayjs from 'dayjs';
import { cn } from 'cn';
import { useTranslation } from 'react-i18next';
import type { MitarbeiterabgleichZusammenfassung } from '../../hooks/useMitarbeiterabgleich/entities/Mitarbeiterabgleich';

const formatDatum = (iso?: string) => dayjs(iso).format('DD.MM.YYYY, HH:mm');

export function AbgleichKopf({
  zusammenfassung: { uebereinstimmend, gesamt, letzterJob, letzterAbruf },
  abweichungen,
  onAbrufStarten,
}: {
  zusammenfassung: MitarbeiterabgleichZusammenfassung;
  abweichungen: number;
  onAbrufStarten: () => void;
}) {
  const { t } = useTranslation();
  const laeuft = letzterJob?.status === 'inProgress';

  return (
    <CardHeader>
      <CardTitle className="text-sm leading-5">
        {t('domain.datev.abgleich.title', { uebereinstimmend, gesamt })}
      </CardTitle>
      <CardDescription className="text-xs leading-4">
        {t('domain.datev.abgleich.abweichungen', { count: abweichungen })}
      </CardDescription>
      <CardAction className="flex flex-col items-end gap-2">
        <Button loading={laeuft} onClick={onAbrufStarten}>
          {t('domain.datev.abgleich.abrufStarten')}
        </Button>
        {letzterAbruf && (
          <Body size="sm" className="text-labels-secondary">
            {t('domain.datev.abgleich.letzterAbruf', {
              datum: formatDatum(letzterAbruf),
            })}
          </Body>
        )}
        <Body
          size="sm"
          className={cn('text-labels-secondary', !laeuft && 'invisible')}>
          {t('domain.datev.abgleich.abrufGestartet', {
            datum: formatDatum(letzterJob?.gestartetAm),
          })}
        </Body>
      </CardAction>
    </CardHeader>
  );
}
